<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="table-responsive">
          <div class="form-inline ml-auto mb-2">
            <div class="button-group"><button class="btn btn-sm btn-hard-primary" @click="refreshList"><i class="fa fa-refresh"></i> Refresh</button></div>
          </div>
          <table class="table table-sm table-hover table-striped">
              <thead>
              <th>Product</th>
              <th>Date</th>
              <th>Ref No.</th>
              <th>Qty</th>
              <th>Uom</th>
              <th class="text-right">Amount</th>
              </thead>
              <tbody>
                  <tr v-for="d in dataRaw" :key="d.id">
                      <td><b @click="setProductNo(d)" style="cursor: pointer;">[{{ d.product_no}}]</b> {{ d.product_name }}</td>
                      <td>{{ d.cost_date | dateFormat('DD/MM/YYYY') }}</td>
                      <td>{{ d.ref_no }}</td>
                      <td>
                        <span class="badge badge-danger" v-if="d.cost_qty < 0">{{ d.cost_qty }}</span>
                      </td>
                      <td>{{ d.uom_id }}</td>
                      <td class="text-right">{{ d.cost_amount | currency }}</td>
                  </tr>
              </tbody>
          </table>
      </div>
    </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, productUrl } from '../../config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'ProductCostSaldMinusList',
  components: {
    Loading
  },
  data () {
    return {
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  methods: {
    setProductNo (cost) {
      var obj = {
        product_no: cost.product_no,
        date: cost.cost_date
      }
      this.$emit('setProductNo', obj)
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        begin: null,
        end: null
      }
      console.log(productUrl + '/cost/get-product-minus')
      await Axios.post(productUrl + '/cost/get-product-minus', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, error)
          throw error
        })
    }
  }
}
</script>
